import { render } from "./MenteeMessages.vue?vue&type=template&id=57badb28"
import script from "./MenteeMessages.vue?vue&type=script&lang=js"
export * from "./MenteeMessages.vue?vue&type=script&lang=js"

import exportComponent from "/root/mentoringplatform-acm/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__